import { fetcher } from "../../utils/fetcher.js";

export const getAllBoards = (projectId) => {
  if (!projectId) {
    throw new Error("projectId is required");
  }
  return fetcher.get(`/api/boards?projectId=${projectId}`);
};
